export default "__VITE_ASSET__K4xUBXUI__"